export const apiName: string = 'motoristas';
export const motoristasRoute: string = 'motoristas';
export const motoristasStorage: string = 'motoristas';
export const motoristasModuleName: any = {plural: 'Motoristas', single: 'Motorista'};

export const motoristasQuery: any = {
  "where":{
    "ativo":true,
    "funcionario": {
      "pessoa": {
        "nome": {"regexp":"/REPLACEHERE/i"}
      }
    }
  },
  "include":[
    {"funcionario": "pessoa"}
  ]
};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/motoristas/shared/data.service.ts
 **/